import { lazy, Suspense, useContext, useEffect } from "react";
import DimensionsContext from "../../../context/dimensions/dimensions";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./GameThumbnail.css";
import "../Thumbnail/Thumbnail.css";
import Loading from "../Loading/Loading";

const Mines = lazy(() => import("../SelectorSvg/Mines"));
const Plinko = lazy(() => import("../SelectorSvg/Plinko"));
const Towers = lazy(() => import("../SelectorSvg/Towers"));
const Dice = lazy(() => import("../SelectorSvg/Dice"));
const Crash = lazy(() => import("../SelectorSvg/Crash"));
const Chicken = lazy(() => import("../SelectorSvg/Chicken"));
const ThumbnailMobile = lazy(() => import("../SelectorSvg/ThumbnailMobile"));
const ThumbnailPC = lazy(() => import("../SelectorSvg/ThumbnailPC"));

interface IGame {
  game: string;
}

export default function GameThumbnail({ game }: IGame) {
  const { x } = useContext(DimensionsContext);
  const { t } = useTranslation();

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);

  return (
    <div id="gamethumbnail" className="thumbnail">
      <h1 className="thumbnail-title">
        {game === "chicken"
          ? "Mission Uncrossable"
          : game === "mines"
          ? "Mines"
          : game === "plinko"
          ? "Plinko"
          : game === "towers"
          ? "Towers"
          : game === "dice"
          ? "Dice"
          : "Crash"}
      </h1>
      <div className="thumbnail-subtitle">
        {game === "chicken"
          ? t("demothumbnail_chicken_subtitle")
          : game === "mines"
          ? t("demothumbnail_mines_subtitle")
          : game === "plinko"
          ? t("demothumbnail_plinko_subtitle")
          : game === "towers"
          ? t("demothumbnail_towers_subtitle")
          : game === "dice"
          ? t("demothumbnail_dice_subtitle")
          : t("demothumbnail_crash_subtitle")}
      </div>
      <div className="game-thumbnail-buttons">
        <button
          onClick={() => document.getElementById("gamedemo")?.scrollIntoView()}
          className="thumbnail-button"
          style={{ margin: 0 }}
        >
          <p>{t("view_button")}</p>
        </button>
        <Link to="/" className="game-thumbnail-button">
          <p>{t("return_button")}</p>
        </Link>
      </div>
      <Suspense fallback={<Loading>Loading</Loading>}>
        <div className="game-thumbnail-svg-container">
          <div className="game-thumbnail-svg" />
          {game === "chicken" ? (
            <Chicken
              width="100%"
              height="100%"
              viewBox={x > 800 ? "0 0 100 404" : "0 0 1324 404"}
            />
          ) : game === "mines" ? (
            <Mines
              width="100%"
              height="100%"
              viewBox={x > 800 ? "0 0 100 530" : "0 0 755 530"}
            />
          ) : game === "plinko" ? (
            <Plinko
              width="100%"
              height="100%"
              viewBox={x > 800 ? "0 0 100 514" : "0 0 763 514"}
            />
          ) : game === "towers" ? (
            <Towers
              width="100%"
              height="100%"
              viewBox={x > 800 ? "0 0 100 524" : "0 0 763 524"}
            />
          ) : game === "dice" ? (
            <Dice
              width="100%"
              height="100%"
              viewBox={x > 800 ? "0 0 100 476" : "0 0 763 476"}
            />
          ) : (
            <Crash
              width="100%"
              height="100%"
              viewBox={x > 800 ? "0 0 100 444" : "0 0 763 444"}
            />
          )}
        </div>

        {x > 800 ? (
          <ThumbnailPC height="100%" width="100%" className="thumbnail-bgsvg" />
        ) : (
          <ThumbnailMobile
            height="100%"
            width="100%"
            className="thumbnail-bgsvg"
          />
        )}
      </Suspense>
    </div>
  );
}
